import { Link, Tooltip, Typography } from "@mui/material";
import { formatNumeroFactura } from "../../../utils/Factura";
import { useVisorFactura } from "./visorFacturaContext";

interface EnlaceFacturaProps {
  facturaId?: string | null;
  numero?: string | null;
  cursiva?: boolean;
}

// Número de una factura relacionada: si se conoce su id es un enlace que abre el visor de consulta; si no, texto.
const EnlaceFactura = ({ facturaId, numero, cursiva = false }: EnlaceFacturaProps) => {
  const { abrir } = useVisorFactura();
  const texto = formatNumeroFactura(numero);
  const estilo = { fontStyle: cursiva ? "italic" : "normal" };

  if (!facturaId) {
    return <Typography component="span" variant="body2" sx={estilo}>{texto}</Typography>;
  }

  return (
    <Tooltip title="Ver factura">
      <Link
        component="button"
        type="button"
        variant="body2"
        underline="hover"
        onClick={() => abrir(facturaId)}
        sx={{ ...estilo, verticalAlign: "baseline" }}
      >
        {texto}
      </Link>
    </Tooltip>
  );
};

export default EnlaceFactura;
